import { createContext } from "react";

export interface isPaymentMethodsItem {
  configured: Boolean;
  payment_method: string;
  setValue(e: Boolean): void
  allowed: Boolean;
}

export const defaultValue = {
  data: new Array<isPaymentMethodsItem>(),
  isButtonLoading: false,
  isChanged: false,
  isLoading: false,
  isSuccess: false,
  loadPaymentMethods: Function,
  noSelectedPaymentMethod: false,
  savePaymentMethods: Function,
  setValue: Function
};

const PaymentMethodsContext = createContext(defaultValue);

export default PaymentMethodsContext;
